module.exports = __webpack_public_path__ + "9ec588fb6b629406648dba7b97bdfcd7.svg";